import { sendEventToJumbo } from '@/utils/jumboClient'
import { JUMBO_EVENTS } from '@/constants/jumboEventNames'
import type {
  JumboEventName,
  PageShownProperties,
  ButtonClickedProperties,
  TabClickedProperties,
  SearchedProperties,
  OptionSelectedProperties,
  PreviewViewedProperties,
} from './types'

const safeTrack = (eventName: JumboEventName, eventProperties: object) => {
  try {
    sendEventToJumbo({ eventName, eventProperties })
  } catch (error) {
    console.error(`[Analytics] ${eventName} failed:`, error)
  }
}

export const trackPageShown = (properties: PageShownProperties) => {
  safeTrack(JUMBO_EVENTS.PAGE_SHOWN, properties)
}

export const trackButtonClicked = (properties: ButtonClickedProperties) => {
  safeTrack(JUMBO_EVENTS.BUTTON_CLICKED, properties)
}

export const trackTabClicked = (properties: TabClickedProperties) => {
  safeTrack(JUMBO_EVENTS.TAB_CLICKED, properties)
}

export const trackSearched = (properties: SearchedProperties) => {
  safeTrack(JUMBO_EVENTS.SEARCHED, properties)
}

export const trackOptionSelected = (properties: OptionSelectedProperties) => {
  safeTrack(JUMBO_EVENTS.OPTION_SELECTED, properties)
}

export const trackPreviewViewed = (properties: PreviewViewedProperties) => {
  safeTrack(JUMBO_EVENTS.PREVIEW_VIEWED, properties)
}
